import './Loader.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Індикатор завантаження.
 *
 * Замість крутного кола з фіолетовою крапкою — тонка брендова смуга і
 * підпис для скрінрідера. Під prefers-reduced-motion смуга не рухається,
 * лишається статичною (див. Loader.css).
 *
 * variant="cards" віддає скелет сітки карток замість смуги — використовується
 * там, де форма майбутнього вмісту відома наперед (каталоги, новини).
 */
export default function Loader({ className = '', variant = 'bar', count = 8 }) {
  const language = useLanguage();
  const label = language === 'en' ? 'Loading' : 'Завантаження';

  if (variant === 'cards') {
    return (
      <div className={`loader-sec loader-sec--cards ${className}`} role='status' aria-live='polite'>
        <span className='visually-hidden'>{label}</span>
        <div className='skeleton-grid'>
          {Array.from({ length: count }, (_, index) => (
            <div className='skeleton-card' key={index} aria-hidden='true'>
              <span className='skeleton-avatar' />
              <span className='skeleton-line skeleton-line--wide' />
              <span className='skeleton-line' />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={`loader-sec ${className}`} role='status' aria-live='polite'>
      <span className='visually-hidden'>{label}</span>
      <span className='loader-bar' aria-hidden='true' />
    </div>
  );
}
